import { render, staticRenderFns } from "./AuctionBoard.vue?vue&type=template&id=7a717666&scoped=true&"
import script from "./AuctionBoard.vue?vue&type=script&lang=js&"
export * from "./AuctionBoard.vue?vue&type=script&lang=js&"
import style0 from "./AuctionBoard.vue?vue&type=style&index=0&id=7a717666&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a717666",
  null
  
)

export default component.exports